import { LoggerLevel } from 'types';

const environmentConfig = {
  environment: 'prodauth',
  applicationId: 'prod-auth-react-header-footer',
  api: {
    homr: 'https://www.dickssportinggoods.com/dcsg-ngx-home/homr/v2/api/v4/content',
    sayt: {
      dsg: { baseUrl: 'https://api-search.dickssportinggoods.com/prodauth/catalog-autosuggest/' },
      gg: { baseUrl: 'https://api-search.dickssportinggoods.com/prodauth/catalog-autosuggest/' },
      pl: { baseUrl: 'https://api-search.dickssportinggoods.com/prodauth/catalog-autosuggest/' },
      mj: { baseUrl: 'https://api-search.dickssportinggoods.com/prodauth/catalog-autosuggest/' },
      g3: { baseUrl: 'https://api-search.dickssportinggoods.com/prodauth/catalog-autosuggest/' },
    },
    availability: {
      dsg: {
        baseUrl: 'https://availability.dickssportinggoods.com',
        key: 'sb-2a63f428-1a20-11ec-b434-3b32fc4423a5',
      },
      gg: {
        baseUrl: 'https://availability.dickssportinggoods.com',
        key: 'sb-2a63f428-1a20-11ec-b434-3b32fc4423a5',
      },
      pl: {
        baseUrl: 'https://availability.dickssportinggoods.com',
        key: 'sb-2a63f428-1a20-11ec-b434-3b32fc4423a5',
      },
      mj: {
        baseUrl: 'https://availability.dickssportinggoods.com',
        key: 'sb-2a63f428-1a20-11ec-b434-3b32fc4423a5',
      },
      g3: {
        baseUrl: 'https://availability.dickssportinggoods.com',
        key: 'sb-2a63f428-1a20-11ec-b434-3b32fc4423a5',
      },
    },
    microService: {
      logger: {
        path: '/spring/msvc/logger/publish',
        host: {
          dsg: {
            baseUrl: 'https://preview.dickssportinggoods.com',
          },
          gg: {
            baseUrl: 'https://preview.golfgalaxy.com',
          },
          pl: {
            baseUrl: 'https://preview.publiclands.com',
          },
          mj: {
            baseUrl: 'https://preview.moosejaw.com',
          },
          g3: {
            baseUrl: 'https://preview.goinggoinggone.com',
          },
        },
      },
    },
    logger: {
      client: {
        level: LoggerLevel.LOG,
      },
      xhr: {
        level: LoggerLevel.LOG, // DO NOT TOUCH
        url: 'https://prod-log-publisher.iso.ap01.pcf.dcsg.com/publish', // same as deploy domain in build.yml
      },
    },
    promotionData: {
      dsg: {
        baseUrl: 'https://gateway.dcsg.com/ws/WCS/v2/api/promotiondescription',
        key: 'c0fcfbe0-9983-11e7-b506-c779759784e8',
        headerEnvValue: 'prdstage',
      },
      gg: {
        baseUrl: 'https://gateway.dcsg.com/ws/WCS/v2/api/promotiondescription',
        key: 'c0fcfbe0-9983-11e7-b506-c779759784e8',
        headerEnvValue: 'prdstage',
      },
      pl: {
        baseUrl: 'https://gateway.dcsg.com/ws/WCS/v2/api/promotiondescription',
        key: 'c0fcfbe0-9983-11e7-b506-c779759784e8',
        headerEnvValue: 'prdstage',
      },
      mj: {
        baseUrl: 'https://gateway.dcsg.com/ws/WCS/v2/api/promotiondescription',
        key: 'c0fcfbe0-9983-11e7-b506-c779759784e8',
        headerEnvValue: 'prdstage',
      },
      g3: {
        baseUrl: 'https://gateway.dcsg.com/ws/WCS/v2/api/promotiondescription',
        key: 'c0fcfbe0-9983-11e7-b506-c779759784e8',
        headerEnvValue: 'prdstage',
      },
    },
  },
};

export default environmentConfig;
